import React, { useEffect, useState } from "react";
import { configShop } from '../../states/configShop';
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const ListaPedido = () => {
    const { dataConfig } = configShop();
    const codigoPais = "es-CO";
    const codigoCurrency = "COP";
    const [lista, setLista] = useState([]);
    const [expandido, setExpandido] = useState(true);

    const obtenerProductos = () => {
        const raw = localStorage.getItem("infoProductoSeleccionado");
        if (raw) {
            setLista(JSON.parse(raw));
        }
    };

    const obtenerPrecioProducto = (producto) => {
        let precioTopping = 0;
        producto.toppings?.forEach((t) => {
            t.topingsSeleccionados?.forEach((s) => { precioTopping += s.price; });
        });
        return (producto.precio + precioTopping) * producto.cantidadProducto;
    };

    const formatCOP = (value) =>
        value.toLocaleString(codigoPais, {
            style: "currency",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            currency: codigoCurrency,
        });

    useEffect(() => { obtenerProductos(); }, []);

    const totalItems = lista.reduce((acc, p) => acc + p.cantidadProducto, 0);

    return (
        <div className="lp-container">
            <button
                className="lp-toggle"
                onClick={() => setExpandido(!expandido)}
                style={{ "--brand": dataConfig?.color_botton }}
            >
                <span className="lp-toggle-label">
                    {totalItems} {totalItems === 1 ? "producto" : "productos"}
                </span>
                {expandido ? <FaChevronUp size={13} /> : <FaChevronDown size={13} />}
            </button>

            {expandido && (
                <ul className="lp-list">
                    {lista.length === 0 ? (
                        <li className="lp-empty">No hay productos en el pedido</li>
                    ) : (
                        lista.map((producto, index) => (
                            <li key={index} className="lp-item">
                                <img
                                    src={producto.fotoPlatoSelec}
                                    alt={producto.nombrePlatoSelec}
                                    className="lp-img"
                                />
                                <div className="lp-info">
                                    <span className="lp-name">
                                        <span className="lp-qty">{producto.cantidadProducto}×</span>
                                        {" "}{producto.nombrePlatoSelec}
                                    </span>
                                    {producto.toppings?.map((topping, ti) =>
                                        topping.topingsSeleccionados?.map((sel, si) => (
                                            <span key={`${ti}-${si}`} className="lp-topping">
                                                + {sel.name}
                                                {sel.price > 0 && ` · ${formatCOP(sel.price)}`}
                                            </span>
                                        ))
                                    )}
                                </div>
                                <span className="lp-price">{formatCOP(obtenerPrecioProducto(producto))}</span>
                            </li>
                        ))
                    )}
                </ul>
            )}
        </div>
    );
};

export default ListaPedido;
